import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, map } from 'rxjs';
import ApiOptionsConfig from '../api-options.config';
import { LawsService } from './laws.service';
import { CategoriesService } from './categories.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { StoreService } from '../../store.service';
import { JurisdictionsService } from './jurisdictions.service';

const BASE_URL = '/regulations';

@Injectable({
  providedIn: 'root'
})
export class RegulationsService {

   accessToken: string = '';
    storeService: StoreService;
    httpClient: HttpClient;

    
  private regulations = [
    {
      id: 1,
      law: 'RESDI-2020-12-GCABA-LOTBA - Especificaciones tecnicas de juego, trazabilidad y transparencia',
      jurisdiction: 'Ciudad Autonoma de Buenos Aires (LOTBA)',
      title: "Articulo 26.- Funcionamiento del RNG (Generador de numeros aleatorios) (1)",
      description: "El Generador de Números Aleatorios deberá cumplir, como mínimo, los siguientes requisitos: ● Los datos aleatorios generados deben ser estadísticamente independientes.",
      category: "Live Games - Information",
      descriptionTranslation:
      {
        eng: 'The Random Number Generator shall meet at least the following requirements:   The randomly generated data shall be statistically independent.',
        ita: 'Il generatore di numeri casuali deve soddisfare almeno i seguenti requisiti:   I dati casuali generati devono essere statisticamente indipendenti.',
        spa: 'El Generador de Números Aleatorios deberá cumplir, como mínimo, los siguientes requisitos: ● Los datos aleatorios generados deben ser estadísticamente independientes.',
      },
      changesLog: [
        {
          title: 'Soccodato Maurizio',
          time: '2020-06-25 03:46',
          changes: [
            {
              section: 'Details',
              change: 'Where customers hold a credit or debit balance, the pages or screens used for gambling and to move money into and out of accounts must display the customer’s current account balance, in the currency of their account (eg dollars, euros or pounds sterling), whenever that customer is logged in. Where it is not practical to display current balance from gambling screens then easily accessible links to this information must be provided.',
            },
            {
              section: 'Article details eng',
              change: 'Where customers hold a credit or debit balance, the pages or screens used for gambling and to move money into and out of accounts must display the customer’s current account balance, in the currency of their account (eg dollars, euros or pounds sterling), whenever that customer is logged in. Where it is not practical to display current balance from gambling screens then easily accessible links to this information must be provided.',
            },
          ]
        },
        {
          title: 'Soccodato Maurizio',
          time: '2020-06-24 22:59',
          changes: [
            {
              section: 'Item Types',
              change: 'Variant',
            },
          ]
        }
      ]
    },
    {
      id: 2,
      law: 'Gambling Act - Riigi Teataja - (In force from: 01.01.2021)',
      jurisdiction: 'Italy',
      title: "2.6 REQUISITI DI GIOCO 2.6.1 - Point 2",
      description: "Non sono ammessi i cosiddetti near-miss game, progettati per dare al giocatore l'impressione di aver sfiorato la vincita massima (più frequentemente di quanto le regole del gioco non permettano naturalmente) per indurlo a continuare a puntare.",
      category: "RNG - Functional and source code analysis",
      descriptionTranslation:
      {
        eng: 'So-called near-miss games are not allowed, designed to give the player the impression that they have touched the maximum win (more frequently than the rules of the game naturally allow) to encourage them to continue betting.',
        ita: 'Non sono ammessi i cosiddetti near-miss game, progettati per dare al giocatore impressione di aver sfiorato la vincita massima (più frequentemente di quanto le regole del gioco non permettano naturalmente) per indurlo a continuare a puntare.',
        spa: 'No se permiten los llamados juegos de near-miss, diseñados para dar al jugador la impresión de haber tocado el premio máximo (más frecuentemente de lo que las reglas del juego naturalmente permiten) para hacer que siga apostando.',
      },
      changesLog: [
        {
          title: 'Soccodato Maurizio',
          time: '2021-09-01 09:35',
          changes: [
            {
              section: 'Article details eng',
              change: 'So-called near-miss games are not allowed, which are designed to give the player the impression that they have hit the maximum winnings (more often than the rules of the game naturally allow) to induce them to continue betting.',
            },
            {
              section: 'Article details ita',
              change: 'Non sono ammessi i cosiddetti near-miss game, progettati per dare al giocatore l’impressione di aver sfiorato la vincita massima (più frequentemente di quanto le regole del gioco non permettano naturalmente) per indurlo a continuare a puntare.',
            },
            {
              section: 'Article details ESP ',
              change: 'No se permiten los llamados juegos near-miss, diseñados para dar al jugador la impresión de haber tocado las ganancias máximas (con más frecuencia de lo que las reglas del juego permiten naturalmente) para inducirlo a seguir apostando.',
            },
          ]
        },
        {
          title: 'Soccodato Maurizio',
          time: '2020-06-24 22:59',
          changes: [
            {
              section: 'Category',
              change: ' Game - Jackpot',
            },
          ]
        }
      ]
    }
  ];

  private lawsSubject = new BehaviorSubject<string[]>([]);
  public laws$ = this.lawsSubject.asObservable();
  private categoriesSubject = new BehaviorSubject<string[]>([]);
  public categories$ = this.categoriesSubject.asObservable();
   private jurisdictionsSubject = new BehaviorSubject<string[]>([]);
  public jurisdictions$ = this.jurisdictionsSubject.asObservable();

  constructor(private lawsService: LawsService, private categoriesService: CategoriesService,private jurisdictionsService: JurisdictionsService) {
    const params = new HttpParams().set('size', '9999');
    this.lawsService.list({params}).subscribe({
      next: (response: any) => {        
        const updatedLaws = response.data.laws
        this.lawsSubject.next(updatedLaws);
      },
      error: (error: any) => {
        console.error('Error fetching laws:', error);
      }
    });
    this.categoriesService.list({params}).subscribe({
      next: (response: any) => {
        
        const updatedCategories = response.data.categories
        this.categoriesSubject.next(updatedCategories);
      },
      error: (error: any) => {
        console.error('Error fetching laws:', error);
      }
    });    
    this.jurisdictionsService.list({ params }).subscribe({
      next: (response: any) => {
        const updatedJurisdictions = response.data.jurisdictions;
        this.jurisdictionsSubject.next(updatedJurisdictions);
      },
      error: (error: any) => {
        console.error('Error fetching jurisdictions:', error);
      }
    });
    this.storeService = inject(StoreService);
    this.httpClient = inject(HttpClient);

    this.storeService.getAuthToken().subscribe(
      (data: any) => { this.accessToken = data ? data['accessToken'] : null }
    )
  }





  GET(url: string, params?: HttpParams): Observable<any> {
    let headers: { [key: string]: string } = {
      'Content-Type': 'application/json'
    }
    if (this.accessToken) {
      headers['Authorization'] = `Bearer ${this.accessToken}`;
    }

    return this.httpClient.get<any>(url, {
      headers,
      params
    });
  }

  POST(url: string, data: any, params?: HttpParams): Observable<any> {
    let headers: { [key: string]: string } = {
      'Content-Type': 'application/json'
    }
    if (this.accessToken) {
      headers['Authorization'] = `Bearer ${this.accessToken}`;
    }

    return this.httpClient.post<any>(url, data, {
      headers,
      params
    });
  }
  PUT(url: string, data: any, params?: HttpParams): Observable<any> {
    let headers: { [key: string]: string } = {
      'Content-Type': 'application/json'
    };

    if (this.accessToken) {
      headers['Authorization'] = `Bearer ${this.accessToken}`;
    }

    return this.httpClient.put<any>(url, data, {
      headers,
      params
    });
  }

  DELETE(url: string, params?: HttpParams): Observable<any> {
    let headers: { [key: string]: string } = {
      'Content-Type': 'application/json'
    }
    if (this.accessToken) {
      headers['Authorization'] = `Bearer ${this.accessToken}`;
    }

    return this.httpClient.delete<any>(url, {
      headers,
      params
    });
  }

  getUrl(path: string): string {
    return `${environment.apiBaseUrl}${path}`
  }



  list(options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(BASE_URL), options?.params);
  }

  detail(regulationId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${regulationId}`), options?.params);
  }

  create(data: any): Observable<any> {
    return this.POST(this.getUrl(BASE_URL), data);
  }

  update(regulationId: number, data: any): Observable<any> {
    return this.PUT(this.getUrl(`${BASE_URL}/${regulationId}`), data);
  }

  delete(regulationId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${regulationId}`));
  }

  getChangesLog(regulationId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${regulationId}/audit-logs`), options?.params);
  }

  getLawsByJurisdiction(jurisdictionId: number): Observable<any> {
     return this.laws$.pipe(
      map((allLaws: any[]) =>
        allLaws
          .filter((law: any) => law.jurisdiction.jurisdictionId == jurisdictionId)
          .map((law: any) => ({ key: law.lawId, value: law.name }))
      )
    );
  }
}
